import React from 'react';
import PropTypes from 'prop-types';
import {AuthorModelV1} from 'resources/augmented/Author/AuthorModel.v1';
import {Icon, Text} from '@albert-io/atomic';
import './author-dashboard-header.scss';

const AuthorDashboardHeaderBio = ({data, isNewAuthor}) => {
  return (
    <div className='author-dashboard-header-bio__container'>
      <div className='author-dashboard-header-bio__profile-picture'>{data.getDisplayName('i')}</div>
      <div className='author-dashboard-header-bio__info'>
        <Text size='xl' bold as='div'>
          {`Welcome${!isNewAuthor ? ` back` : ''}, ${data.getFirstName()}`}
        </Text>
        <div>
          <Icon icon='user' color='black' emphasis='disabled' className='u-mar-r_2' />
          <Text size='m' emphasis='low'>
            {data.getUsername()}
          </Text>
        </div>
        <div className='author-dashboard-header-bio__useremail'>
          <Icon icon='envelope' color='black' emphasis='disabled' className='u-mar-r_2' />
          <Text size='m' emphasis='low'>
            {data.getEmail()}
          </Text>
        </div>
      </div>
    </div>
  );
};

AuthorDashboardHeaderBio.propTypes = {
  data: PropTypes.instanceOf(AuthorModelV1),
  isNewAuthor: PropTypes.bool
};

export default AuthorDashboardHeaderBio;
